import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { capitalize } from '@material-ui/core/utils';
import { Button } from '@material-ui/core'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  var styleContained = function styleContained(color) {
    return {
      boxShadow: theme.shadows[25][color],
      color: theme.palette[color].contrastText,
      backgroundColor: theme.palette[color].main,
      '&:hover': {
        backgroundColor: theme.palette[color].dark,
        color: theme.palette[color].contrastText
      }
    };
  };

  var styleOutlined = function styleOutlined(color) {
    return {
      color: theme.palette[color].darker,
      border: "1px solid ".concat(alpha(theme.palette[color].main, 0.48)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette[color].main),
        backgroundColor: alpha(theme.palette[color].darker, theme.palette.action.hoverOpacity)
      }
    };
  };

  var textOutlined = function textOutlined(color) {
    return {
      color: theme.palette[color].darker,
      '&:hover': {
        backgroundColor: alpha(theme.palette[color].darker, theme.palette.action.hoverOpacity)
      }
    };
  };

  return {
    // Contained
    containedPrimary: styleContained('primary'),
    containedInfo: styleContained('info'),
    containedSuccess: styleContained('success'),
    containedWarning: styleContained('warning'),
    containedError: styleContained('error'),
    containedWhite: {
      boxShadow: theme.shadows[25].z8,
      color: theme.palette.getContrastText(theme.palette.common.white),
      backgroundColor: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.grey[300]
      }
    },
    // Outlined
    outlinedPrimary: styleOutlined('primary'),
    outlinedInfo: styleOutlined('info'),
    outlinedSuccess: styleOutlined('success'),
    outlinedWarning: styleOutlined('warning'),
    outlinedError: styleOutlined('error'),
    outlinedWhite: {
      color: theme.palette.common.white,
      border: "1px solid ".concat(alpha(theme.palette.common.white, 0.48)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.common.white),
        backgroundColor: alpha(theme.palette.common.white, theme.palette.action.hoverOpacity)
      }
    },
    // Text
    textPrimary: textOutlined('primary'),
    textInfo: textOutlined('info'),
    textSuccess: textOutlined('success'),
    textWarning: textOutlined('warning'),
    textError: textOutlined('error'),
    textWhite: {
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, theme.palette.action.hoverOpacity)
      }
    }
  };
});
export var MButton = forwardRef(function (_a, ref) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'primary' : _a$color,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'text' : _a$variant,
      children = _a.children,
      className = _a.className,
      other = __rest(_a, ["color", "variant", "children", "className"]);

  var classes = useStyles();

  if (color === 'inherit' || color === 'secondary') {
    return React.createElement(Button, Object.assign({
      ref: ref,
      color: color,
      variant: variant,
      className: className
    }, other), children);
  }

  return React.createElement(Button, Object.assign({
    ref: ref,
    variant: variant,
    className: clsx(classes[variant], _defineProperty({}, classes["".concat(variant).concat(capitalize(color))], color), className)
  }, other), children);
});